<template>
    <div class="devices-list__block scenario-group" v-if="scenarioGroup" :class="!showLocation ? 'scenario-group__low' : ''">
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <template v-slot:actions>
                        <v-icon class="icon-expand" aria-hidden="false">$expand</v-icon>
                    </template>
                    <div class="group-header">
                        <v-flex xs12 d-flex align-center v-if="scenarioGroup.location && showLocation">
                            <div class="note-row ma-0 pb-1">
                                {{scenarioGroup.location}}
                            </div>
                        </v-flex>
                        <div class="group-header__content">
                            <v-layout row class="devices-list__block__title">
                                <v-flex class="title-block">
                                    <div class="title-block__name">
                                        {{ scenarioGroup.name }}
                                    </div>
                                </v-flex>
                                <v-flex class="btn-block">
                                    <div class="d-inline-flex">
                                        <v-switch
                                            v-model="scenarioGroup.enabled"
                                            inset
                                            dense
                                            hide-details
                                            class="pa-0"
                                            color="#FF8484"
                                            :loading="loading"
                                            @click.stop.prevent="changeGroupState"
                                        ></v-switch>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <div v-for="(scenario, index) in scenarioGroup.scenarios" :key="'scenarioGroup' + index">
                        <ScenarioSwitch :scenario="scenario" :available="available" group showLocation/>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import ScenarioSwitch from "@/components/ScenarioSwitch";

export default {
    name: "ScenarioGroup",
    components: {ScenarioSwitch},
    props: {
        group: {
            type: Object,
            required: true,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
        available: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            scenarioGroup: [],
            loading: false,
        };
    },
    created() {
        this.scenarioGroup = JSON.parse(JSON.stringify(this.group));
    },
    watch: {
        group(val) {
            if (val) {
                this.scenarioGroup = JSON.parse(JSON.stringify(val));
                this.loading = false;
            }
        },
    },
    methods: {
        changeGroupState() {
            if (this.scenarioGroup.scenarios.length > 0) {
                this.loading = true;
                this.$http.put('/scenarios/guest/scenario/' + this.scenarioGroup.scenarios[0].uid + '/state', {
                    enabled: this.scenarioGroup.enabled
                })
                    .catch((error) => {
                        console.log(error);
                        this.loading = false;
                    });
            }
        },
    },
}
</script>
